// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__KLYmu","title":"BackImages_title__1H0qo","images":"BackImages_images__24Myz"};